import React from "react";

const Bronze = () => {
  return (
    <svg
      width="4"
      viewBox="0 0 57 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M55.4756 53.3851L39.4766 13.3871C37.8526 9.27515 33.2046 7.26714 29.0926 8.89114C27.0366 9.70714 25.4046 11.3311 24.5966 13.3871L8.59759 53.3851C7.83759 55.2891 7.83759 57.4011 8.59759 59.3051L24.5966 99.3031C26.2206 103.415 30.8686 105.423 34.9806 103.799C37.0366 102.983 38.6686 101.359 39.4766 99.3031L55.4756 59.3051C56.2276 57.4001 56.2276 55.2891 55.4756 53.3851Z"
        fill="#6C5836"
      />
      <path
        d="M47.4756 45.3851L31.4766 5.38715C29.8526 1.27515 25.2046 -0.732856 21.0926 0.891144C19.0366 1.70714 17.4046 3.33115 16.5966 5.38715L0.597588 45.3851C-0.162412 47.2891 -0.162412 49.4011 0.597588 51.3051L16.5966 91.3031C18.2206 95.4151 22.8686 97.4231 26.9796 95.7991C29.0356 94.9831 30.6676 93.3591 31.4756 91.3031L47.4746 51.3051C48.2276 49.4011 48.2276 47.2891 47.4756 45.3851Z"
        fill="#E0CDBA"
      />
      <path
        d="M31.4766 91.3032L47.4756 51.3052C48.2356 49.4012 48.2356 47.2892 47.4756 45.3852L31.4766 5.3872C30.2766 2.3472 24.0366 5.3872 24.0366 16.3462V96.3422C27.3086 96.3432 30.2606 94.3512 31.4766 91.3032Z"
        fill="#C5AD83"
      />
    </svg>
  );
};

export default Bronze;
